"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var apiTva = _interopRequireWildcard(require("@/api/tva"));

var apiCommande = _interopRequireWildcard(require("@/api/commande"));

var apiFacture = _interopRequireWildcard(require("@/api/facture"));

var apiReglement = _interopRequireWildcard(require("@/api/reglement"));

var _utils = require("@/helpers/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var state = {
  tauxTva: [],
  // ---
  commandes: [],
  factures: [],
  facture: {},
  reglements: [],
  // ---
  creances: [],
  syntheseList: [],
  origineReglement: '',
  // ---
  facturationSoldee: false
};
var mutations = {
  // --- TAUX de TVA --- //
  SET_TAUX_TVA: function SET_TAUX_TVA(sate, tauxTva) {
    state.tauxTva = tauxTva;
  },
  // --- COMMANDES --- //
  SET_COMMANDES: function SET_COMMANDES(sate, commandes) {
    state.commandes = commandes;
  },
  ADD_COMMANDE: function ADD_COMMANDE(state, commande) {
    state.commandes.push(commande);
  },
  UPD_COMMANDE: function UPD_COMMANDE(state, commande) {
    var index = state.commandes.findIndex(function (x) {
      return x.id === commande.id;
    });
    state.commandes[index] = commande;
  },
  DEL_COMMANDE: function DEL_COMMANDE(state, commande) {
    var index = state.commandes.findIndex(function (x) {
      return x.id === commande.id;
    });
    state.commandes.splice(index, 1);
  },
  BULK_DEL_COMMANDE: function BULK_DEL_COMMANDE(state, selection) {
    var commandeIdsList = selection.split(',');
    commandeIdsList.forEach(function (commandeId) {
      var index = state.commandes.findIndex(function (x) {
        return x.id === commandeId;
      });
      state.commandes.splice(index, 1);
    });
  },
  // --- FACTURES --- //
  SET_FACTURE: function SET_FACTURE(state, facture) {
    state.facture = facture;
  },
  SET_FACTURES: function SET_FACTURES(state, factures) {
    state.factures = factures;
  },
  ADD_FACTURE: function ADD_FACTURE(state, facture) {
    /*
    // Récupération de la commande parente de la facture
    const commande = state.commandes.find(x => x.id === facture.id_commande)
    if (commande) {
      // On incrémente le nombre de factures liées à la commande directement dans le store
      commande.nb_facture++
    }
    // injection de la commande parente de la facture
    facture.commande = commande || null
    // injection de la TVA liée à la facture
    const tva = state.tauxTva.find(x => x.id === facture.id_tva)
    facture.tva = tva || null
    */
    state.factures.push(facture);
  },
  UPD_FACTURE: function UPD_FACTURE(state, facture) {
    /*
    // injection de la commande parente de la facture
    const commande = state.commandes.find(x => x.id === facture.id_commande)
    facture.commande = commande || null
    // injection de la TVA liée à la facture
    const tva = state.tauxTva.find(x => x.id === facture.id_tva)
    facture.tva = tva || null
    */
    var index = state.factures.findIndex(function (x) {
      return x.id === facture.id;
    });
    state.factures[index] = facture;
  },
  SET_FACTURE_COMMENTAIRE: function SET_FACTURE_COMMENTAIRE(state, payload) {
    var facture = state.factures.find(function (x) {
      return x.id === payload.id;
    });

    if (facture) {
      facture.commentaire = payload.commentaire;
    }
  },
  SET_FACTURE_FICHIER: function SET_FACTURE_FICHIER(state, payload) {
    var facture = state.factures.find(function (x) {
      return x.id === payload.id;
    });

    if (facture) {
      facture.fichier = payload.fichier;
      facture.nom_original = payload.nom_original;
    }
  },
  UNSET_FACTURE_FICHIER: function UNSET_FACTURE_FICHIER(state, id) {
    var facture = state.factures.find(function (x) {
      return x.id === id;
    });

    if (facture) {
      facture.fichier = null;
      facture.nom_original = null;
    }
  },
  DEL_FACTURE: function DEL_FACTURE(state, facture) {
    var index = state.factures.findIndex(function (x) {
      return x.id === facture.id;
    });
    state.factures.splice(index, 1);
    /*
    // commande parente de la facture
    const commande = state.commandes.find(x => x.id === facture.commande.id)
    if (commande) {
      const factureByCommande = state.factures.filter(x => x.id_commande === commande.id)
      // Nombre de factures
      commande.nb_facture = factureByCommande.length
      // Montant total facturé
      const values = factureByCommande.map(item => Number(item.mt_a_percevoir_ttc))
      commande.montant_facture = getTotal(values)
    }
     // règlements liés à la facture
    let reglements = state.reglements.filter(x => x.id_facture === facture.id)
    reglements.forEach((row) => {
      // Facture parente
      row.facture = null
    })
     // règlements liés à la facture
    reglements = state.reglements.filter(x => x.id_imputation === facture.id)
    reglements.forEach((row) => {
      // Facture à imputer
      row.imputation = null
    })
    */
  },
  BULK_DEL_FACTURE: function BULK_DEL_FACTURE(state, selection) {
    var factureIdsList = selection.split(',');
    factureIdsList.forEach(function (factureId) {
      var index = state.factures.findIndex(function (x) {
        return x.id === factureId;
      });
      /*
      // commande parente de la facture (avant de supprimer la facture pour utiliser l'id_commande)
      const commande = state.commandes.find(x => x.id === state.factures[index].commande_id)
      */
      // Suppression de la facture du store global

      state.factures.splice(index, 1);
      /*
      if (commande) {
        // actualisation du nombre de factures liées à cette commande
        commande.nb_facture = state.factures.filter(x => x.id_commande === commande.id).length
      }
      */
    });
  },
  // --- REGLEMENTS --- //
  SET_REGLEMENTS: function SET_REGLEMENTS(state, reglements) {
    state.reglements = reglements;
  },
  ADD_REGLEMENT: function ADD_REGLEMENT(state, reglement) {
    /*
    // Récupération de la facture parente du reglement
    const facture = state.factures.find(x => x.id === reglement.id_facture)
    if (facture) {
      // On incrémente le nombre de reglements liés à la facture directement dans le store
      facture.nb_reglement++
    }
    // injection de la facture parente du reglement
    reglement.facture = facture || null
    */
    state.reglements.push(reglement);
  },
  UPD_REGLEMENT: function UPD_REGLEMENT(state, reglement) {
    /*
    // injection de la facture parente du reglement
    const facture = state.factures.find(x => x.id === reglement.id_facture)
    reglement.facture = facture || null
    */
    var index = state.reglements.findIndex(function (x) {
      return x.id === reglement.id;
    });
    state.reglements[index] = reglement;
  },
  DEL_REGLEMENT: function DEL_REGLEMENT(state, reglement) {
    var index = state.reglements.findIndex(function (x) {
      return x.id === reglement.id;
    });
    state.reglements.splice(index, 1);
    /*
    // facture parente du reglement
    const facture = state.factures.find(x => x.id === reglement.facture.id)
    if (facture) {
      // actualisation du nombre de reglements liés à cette facture
      facture.nb_reglement = state.reglements.filter(x => x.id_facture === facture.id).length
    }
    */
  },
  BULK_DEL_REGLEMENT: function BULK_DEL_REGLEMENT(state, selection) {
    var reglementIdsList = selection.split(',');
    reglementIdsList.forEach(function (reglementId) {
      reglementId = Number.parseInt(reglementId);
      var index = state.reglements.findIndex(function (x) {
        return x.id === reglementId;
      });
      /*
      // facture parente du reglement (avant de supprimer la reglement pour utiliser l'id_facture)
      const facture = state.factures.find(x => x.id === state.reglements[index].id_facture)
      // Suppression du reglement du store global
      */

      state.reglements.splice(index, 1);
      /*
      if (facture) {
        // actualisation du nombre de reglements liés à cette facture
        facture.nb_reglement = state.reglements.filter(x => x.id_facture === facture.id).length
      }
      */
    });
  },
  // --- CREANCES --- //
  SET_CREANCES: function SET_CREANCES(state, creances) {
    state.creances = creances;
  },
  SET_SYNTHESE_LIST: function SET_SYNTHESE_LIST(state, list) {
    state.syntheseList = list;
  },
  SET_CREANCE_COMMENTAIRE: function SET_CREANCE_COMMENTAIRE(state, payload) {
    var creance = state.creances.find(function (x) {
      return x.facture.id === payload.id;
    });

    if (creance) {
      creance.facture.commentaire = payload.commentaire;
    }
  },
  SET_ORIGINE_REGLEMENT: function SET_ORIGINE_REGLEMENT(state, origine) {
    state.origineReglement = origine;
  },
  SET_FACTURATION_SOLDEE: function SET_FACTURATION_SOLDEE(state, estSoldee) {
    state.facturationSoldee = estSoldee === true;
  }
};
var actions = {
  init: function init(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    commit('SET_ORIGINE_REGLEMENT', 'affaire');
    return dispatch('hydrate', true);
  },
  getData: function () {
    var _getData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
      var commit, dispatch, rootState, affaire, tauxTva, commandes, factures, reglements;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit, dispatch = _ref2.dispatch, rootState = _ref2.rootState;
              _context.prev = 1;
              // On utilise l'affaire stockée dans le state du store 'affaire'
              affaire = rootState.affaire.affaire; // Liste des taux de TVA

              _context.next = 5;
              return apiTva.getAll().then(function (results) {
                return results;
              });

            case 5:
              tauxTva = _context.sent;
              _context.next = 8;
              return apiCommande.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 8:
              commandes = _context.sent;
              _context.next = 11;
              return apiFacture.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 11:
              factures = _context.sent;
              _context.next = 14;
              return apiReglement.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 14:
              reglements = _context.sent;
              commit('SET_TAUX_TVA', tauxTva);
              commit('SET_COMMANDES', commandes);
              commit('SET_FACTURES', factures);
              commit('SET_REGLEMENTS', reglements);
              return _context.abrupt("return", true);

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              return _context.abrupt("return", new Error(_context.t0));

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 22]]);
    }));

    function getData(_x) {
      return _getData.apply(this, arguments);
    }

    return getData;
  }(),
  getFacturationSoldeeStatusByAffaireId: function getFacturationSoldeeStatusByAffaireId(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state,
        rootState = _ref3.rootState;
    // On utilise l'affaire stockée dans le state du store 'affaire'
    var affaire = rootState.affaire.affaire;
    return new Promise(function (resolve, reject) {
      apiFacture.getFacturationSoldeeStatusByAffaireId(affaire.id).then(function (results) {
        // console.log('getFacturationSoldeeStatusByAffaireId: results', results)
        var soldeGlobalAffaire = results[0].facture_solde;
        commit('SET_FACTURATION_SOLDEE', soldeGlobalAffaire === 0);
        resolve(results);
      }).catch(function (error) {
        console.warn('error', error);
        reject(error);
      });
    });
  },
  hydrate: function () {
    var _hydrate = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref4) {
      var commit,
          dispatch,
          state,
          rootState,
          getDataBefore,
          debug,
          tauxTva,
          commandes,
          factures,
          reglements,
          affaire,
          _args2 = arguments;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit, dispatch = _ref4.dispatch, state = _ref4.state, rootState = _ref4.rootState;
              getDataBefore = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              debug = false;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] -- STARTED');
              _context2.prev = 4;
              tauxTva = [];
              commandes = [];
              factures = [];
              reglements = [];
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1. --> Loading datas');

              if (!(getDataBefore === true)) {
                _context2.next = 32;
                break;
              }

              // On utilise l'affaire stockée dans le state du store 'affaire'
              affaire = rootState.affaire.affaire; // Liste des taux de TVA

              _context2.next = 14;
              return apiTva.getAll().then(function (results) {
                return results;
              });

            case 14:
              tauxTva = _context2.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.1.1 --> Get tauxTva by API call');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.1.2 --> Commit tauxTva');
              commit('SET_TAUX_TVA', tauxTva); // Liste des commandes liées à l'affaire

              _context2.next = 20;
              return apiCommande.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 20:
              commandes = _context2.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.2 --> Get commandes by API call'); // Liste des factures liées à l'affaire

              _context2.next = 24;
              return apiFacture.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 24:
              factures = _context2.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.3 --> Get factures by API call'); // Liste des règlements liés à l'affaire

              _context2.next = 28;
              return apiReglement.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 28:
              reglements = _context2.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.4 --> Get reglements by API call');
              _context2.next = 40;
              break;

            case 32:
              tauxTva = state.tauxTva;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.1 --> Get tauxTva from the state');
              commandes = state.commandes;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.2 --> Get commandes from the state');
              factures = state.factures;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.3 --> Get factures from the state');
              reglements = state.reglements;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.4 --> Get reglements from the state');

            case 40:
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2. --> Hydrating datas');
              /* ---------------------------------------
               *  Hydratation: Injection de propriété pour chaque commande
               * ---------------------------------------
               *
               *   - nb_facture: nombre de factures
               *   - montant_facture: somme des factures
               *
               */

              commandes.forEach(function (row) {
                var factureByCommande = factures.filter(function (x) {
                  return x.id_commande === row.id;
                }); // Nombre de factures

                row.nb_facture = factureByCommande.length; // Montant total facturé

                var values = factureByCommande.map(function (item) {
                  return Number(item.montant + item.rev_actu);
                });
                row.montant_facture = (0, _utils.getTotal)(values); // Pourcentage d'avancement

                row.pourcentage_avancement = row.montant_facture / row.montant; // Solde HT à facturer

                row.solde_ht_a_facturer = row.montant - row.montant_facture;
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.1.1 --> Hydrate commandes');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.1.2 --> Commit commandes');
              commit('SET_COMMANDES', commandes);
              /* ---------------------------------------
               *  Hydratation: Injection de propriétés pour chaque facture
               * ---------------------------------------
               *
               *   - commande: commande parente
               *   - tva: taux de TVA utilisé
               *   - nb_reglement: nombre de règlements
               *   - montant_regle: somme des règlements
               *   - nb_imputation: nombre d'imputations
               *   - montant_impute: somme des règlements imputés
               *   - solde: solde à régler
               *   - idc_imputable: la facture est-elle imputable
               *   - anneemois: Période: Année + Mois (YYYYMM)
               *
               */
              // let soldeGlobalAffaire = 0

              factures.forEach(function (row) {
                // Commande parente
                row.commande = commandes.find(function (x) {
                  return x.id === row.id_commande;
                }) || null; // Taux de TVA

                row.tva = tauxTva.find(function (x) {
                  return x.id === row.id_tva;
                }) || ''; // Règlements

                var reglementByFacture = reglements.filter(function (x) {
                  return x.id_facture === row.id;
                }); // Nombre de règlements

                row.nb_reglement = reglementByFacture.length; // Montant total réglé

                var values = reglementByFacture.map(function (item) {
                  return Number(item.montant);
                });
                row.montant_regle = (0, _utils.getTotal)(values); // Imputations

                var imputationByFacture = reglements.filter(function (x) {
                  return x.id_imputation === row.id;
                }); // Nombre d'imputations

                row.nb_imputation = imputationByFacture.length; // Montant total imputé

                values = imputationByFacture.map(function (item) {
                  return Number(item.montant);
                });
                row.montant_impute = (0, _utils.getTotal)(values); // Montant HT : Mntant + Révision Actualisation

                row.montant_ht = row.montant + row.rev_actu; // Montant réglé déduction faite des montants imputés sur cette facture

                row.montant_regle_moins_impute = row.montant_regle - row.montant_impute; // Montant avant Paiement direct Sous-Traitant

                row.mt_avant_paiement_direct_ttc = row.mt_a_percevoir_ttc + row.mt_paiement_direct_st; // Solde à régler

                row.solde = row.mt_a_percevoir_ttc + row.retenue_garantie - row.montant_regle + row.montant_impute; // soldeGlobalAffaire += row.solde - row.retenue_garantie
                // Les factures imputables ont un solde négatif

                row.idc_imputable = row.solde < 0; // Période de gestion : Année + Mois (YYYYMM)

                row.anneemois = row.date_facture.substring(0, 4) + '' + row.date_facture.substring(5, 7);
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.2.1 --> Hydrate factures');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.2.2 --> Commit factures');
              commit('SET_FACTURES', factures); // commit('SET_FACTURATION_SOLDEE', (soldeGlobalAffaire === 0))
              // console.log('soldeGlobalAffaire', soldeGlobalAffaire)

              /* ---------------------------------------
               *  Hydratation: Injection de propriété pour chaque règlement
               * ---------------------------------------
               *
               *   - facture: la facture parente du règlement
               *   - imputation: la facture à imputer (si le mode de paiement est imputation)
               *
               */

              reglements.forEach(function (row) {
                // Facture parente
                row.facture = factures.find(function (x) {
                  return x.id === row.id_facture;
                }) || null; // Facture à imputer

                row.imputation = factures.find(function (x) {
                  return x.id === row.id_imputation;
                }) || null;
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.3.1 --> Hydrate reglements');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.3.2 --> Commit reglements');
              commit('SET_REGLEMENTS', reglements);
              _context2.next = 55;
              return dispatch('getFacturationSoldeeStatusByAffaireId');

            case 55:
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] -- ENDED');
              return _context2.abrupt("return", true);

            case 59:
              _context2.prev = 59;
              _context2.t0 = _context2["catch"](4);
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] -- ENDED with error'); // return new Error(error)

              console.error(_context2.t0);

            case 63:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 59]]);
    }));

    function hydrate(_x2) {
      return _hydrate.apply(this, arguments);
    }

    return hydrate;
  }(),
  hydrateByFacture: function () {
    var _hydrateByFacture = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref5) {
      var commit, state, rootState, debug, tauxTva, factures, facture, reglements;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit, state = _ref5.state, rootState = _ref5.rootState;
              debug = false;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] -- STARTED');
              _context3.prev = 3;
              tauxTva = []; // let commandes = []

              factures = state.factures;
              facture = state.facture;
              reglements = [];
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 1. --> Loading datas'); // Liste des taux de TVA

              _context3.next = 11;
              return apiTva.getAll().then(function (results) {
                return results;
              });

            case 11:
              tauxTva = _context3.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 1.1.1 --> Get tauxTva by API call');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 1.1.2 --> Commit tauxTva');
              commit('SET_TAUX_TVA', tauxTva);
              /*
              // Liste des commandes liées à l'affaire
              commandes = await apiCommande.getAllByAffaireId(affaire.id)
                .then(results => {
                  return results
                })
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 1.2 --> Get commandes by API call')
              */
              // Liste des règlements liés à l'affaire

              _context3.next = 17;
              return apiReglement.getAllByFactureId(facture.id).then(function (results) {
                return results;
              });

            case 17:
              reglements = _context3.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 1.3 --> Get reglements by API call');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 2. --> Hydrating datas');
              /* ---------------------------------------
               *  Hydratation: Injection de propriété pour chaque commande
               * ---------------------------------------
               *
               *   - nb_facture: nombre de factures
               *   - montant_facture: somme des factures
               *
               */

              /*
              commandes.forEach((row) => {
                let factureByCommande = factures.filter(x => x.id_commande === row.id)
                // Nombre de factures
                row.nb_facture = factureByCommande.length
                // Montant total facturé
                let values = factureByCommande.map(item => Number(item.montant + item.rev_actu))
                row.montant_facture = getTotal(values)
              })
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.1.1 --> Hydrate commandes')
              if (debug) console.log('   [Facturation Store][Action  ] [hydrate] 2.1.2 --> Commit commandes')
              commit('SET_COMMANDES', commandes)
              */

              /* ---------------------------------------
               *  Hydratation: Injection de propriétés pour chaque facture
               * ---------------------------------------
               *
               *   - commande: commande parente
               *   - tva: taux de TVA utilisé
               *   - nb_reglement: nombre de règlements
               *   - montant_regle: somme des règlements
               *   - nb_imputation: nombre d'imputations
               *   - montant_impute: somme des règlements imputés
               *   - solde: solde à régler
               *   - idc_imputable: la facture est-elle imputable
               *   - anneemois: Période: Année + Mois (YYYYMM)
               *
               */

              factures.forEach(function (row) {
                // Commande parente
                // row.commande = commandes.find(x => x.id === row.id_commande) || null
                // Taux de TVA
                row.tva = tauxTva.find(function (x) {
                  return x.id === row.id_tva;
                }) || ''; // Règlements

                var reglementByFacture = reglements.filter(function (x) {
                  return x.id_facture === row.id;
                }); // Nombre de règlements

                row.nb_reglement = reglementByFacture.length; // Montant total réglé

                var values = reglementByFacture.map(function (item) {
                  return Number(item.montant);
                });
                row.montant_regle = (0, _utils.getTotal)(values); // Imputations

                var imputationByFacture = reglements.filter(function (x) {
                  return x.id_imputation === row.id;
                }); // Nombre d'imputations

                row.nb_imputation = imputationByFacture.length; // Montant total imputé

                values = imputationByFacture.map(function (item) {
                  return Number(item.montant);
                });
                row.montant_impute = (0, _utils.getTotal)(values); // Montant HT : Mntant + Révision Actualisation

                row.montant_ht = row.montant + row.rev_actu; // Montant réglé déduction faite des montants imputés sur cette facture

                row.montant_regle_moins_impute = row.montant_regle - row.montant_impute; // Montant avant Paiement direct Sous-Traitant

                row.mt_avant_paiement_direct_ttc = row.mt_a_percevoir_ttc + row.mt_paiement_direct_st; // Solde à régler

                row.solde = row.mt_a_percevoir_ttc + row.retenue_garantie - row.montant_regle + row.montant_impute; // Les factures imputables ont un solde négatif

                row.idc_imputable = row.solde < 0; // Période de gestion : Année + Mois (YYYYMM)

                row.anneemois = row.date_facture.substring(0, 4) + '' + row.date_facture.substring(5, 7);
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 2.1.1 --> Hydrate factures');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 2.1.2 --> Commit factures');
              commit('SET_FACTURES', factures);
              /* ---------------------------------------
               *  Hydratation: Injection de propriété pour chaque règlement
               * ---------------------------------------
               *
               *   - facture: la facture parente du règlement
               *   - imputation: la facture à imputer (si le mode de paiement est imputation)
               *
               */

              reglements.forEach(function (row) {
                // Facture parente
                row.facture = factures.find(function (x) {
                  return x.id === row.id_facture;
                }) || null; // Facture à imputer

                row.imputation = factures.find(function (x) {
                  return x.id === row.id_imputation;
                }) || null;
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 2.3.1 --> Hydrate reglements');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] 2.3.2 --> Commit reglements');
              commit('SET_REGLEMENTS', reglements);
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] -- ENDED');
              return _context3.abrupt("return", true);

            case 32:
              _context3.prev = 32;
              _context3.t0 = _context3["catch"](3);
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateByFacture] -- ENDED with error'); // return new Error(error)

              console.error(_context3.t0);

            case 36:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 32]]);
    }));

    function hydrateByFacture(_x3) {
      return _hydrateByFacture.apply(this, arguments);
    }

    return hydrateByFacture;
  }(),
  hydrateCreances: function () {
    var _hydrateCreances = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee4(_ref6) {
      var commit,
          state,
          rootState,
          getDataBefore,
          debug,
          tauxTva,
          commandes,
          factures,
          reglements,
          affaire,
          _args4 = arguments;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref6.commit, state = _ref6.state, rootState = _ref6.rootState;
              getDataBefore = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
              debug = false;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] -- STARTED');
              _context4.prev = 4;
              tauxTva = [];
              commandes = [];
              factures = [];
              reglements = [];
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1. --> Loading datas');

              if (!(getDataBefore === true)) {
                _context4.next = 32;
                break;
              }

              // On utilise l'affaire stockée dans le state du store 'affaire'
              affaire = rootState.affaire.affaire; // Liste des taux de TVA

              _context4.next = 14;
              return apiTva.getAll().then(function (results) {
                return results;
              });

            case 14:
              tauxTva = _context4.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.1.1 --> Get tauxTva by API call');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.1.2 --> Commit tauxTva');
              commit('SET_TAUX_TVA', tauxTva); // Liste des commandes liées à l'affaire

              _context4.next = 20;
              return apiCommande.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 20:
              commandes = _context4.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.2 --> Get commandes by API call'); // Liste des factures liées à l'affaire

              _context4.next = 24;
              return apiFacture.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 24:
              factures = _context4.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.3 --> Get factures by API call'); // Liste des règlements liés à l'affaire

              _context4.next = 28;
              return apiReglement.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 28:
              reglements = _context4.sent;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.4 --> Get reglements by API call');
              _context4.next = 40;
              break;

            case 32:
              tauxTva = state.tauxTva;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.1 --> Get tauxTva from the state');
              commandes = state.commandes;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.2 --> Get commandes from the state');
              factures = state.factures;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.3 --> Get factures from the state');
              reglements = state.reglements;
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 1.4 --> Get reglements from the state');

            case 40:
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 2. --> Hydrating datas');
              /* ---------------------------------------
               *  Hydratation: Injection de propriété pour chaque commande
               * ---------------------------------------
               *
               *   - nb_facture: nombre de factures
               *   - montant_facture: somme des factures
               *
               */

              commandes.forEach(function (row) {
                var factureByCommande = factures.filter(function (x) {
                  return x.id_commande === row.id;
                }); // Nombre de factures

                row.nb_facture = factureByCommande.length; // Montant total facturé

                var values = factureByCommande.map(function (item) {
                  return Number(item.montant + item.rev_actu);
                });
                row.montant_facture = (0, _utils.getTotal)(values);
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 2.1.1 --> Hydrate commandes');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 2.1.2 --> Commit commandes');
              commit('SET_COMMANDES', commandes);
              /* ---------------------------------------
               *  Hydratation: Injection de propriétés pour chaque facture
               * ---------------------------------------
               *
               *   - commande: commande parente
               *   - tva: taux de TVA utilisé
               *   - nb_reglement: nombre de règlements
               *   - montant_regle: somme des règlements
               *   - nb_imputation: nombre d'imputations
               *   - montant_impute: somme des règlements imputés
               *   - solde: solde à régler
               *   - idc_imputable: la facture est-elle imputable
               *   - anneemois: Période: Année + Mois (YYYYMM)
               *
               */

              factures.forEach(function (row) {
                // Commande parente
                row.commande = commandes.find(function (x) {
                  return x.id === row.id_commande;
                }) || null; // Taux de TVA

                row.tva = tauxTva.find(function (x) {
                  return x.id === row.id_tva;
                }) || ''; // Règlements

                var reglementByFacture = reglements.filter(function (x) {
                  return x.id_facture === row.id;
                }); // Nombre de règlements

                row.nb_reglement = reglementByFacture.length; // Montant total réglé

                var values = reglementByFacture.map(function (item) {
                  return Number(item.montant);
                });
                row.montant_regle = (0, _utils.getTotal)(values); // Imputations

                var imputationByFacture = reglements.filter(function (x) {
                  return x.id_imputation === row.id;
                }); // Nombre d'imputations

                row.nb_imputation = imputationByFacture.length; // Montant total imputé

                values = imputationByFacture.map(function (item) {
                  return Number(item.montant);
                });
                row.montant_impute = (0, _utils.getTotal)(values); // Montant HT : Mntant + Révision Actualisation

                row.montant_ht = row.montant + row.rev_actu; // Montant réglé déduction faite des montants imputés sur cette facture

                row.montant_regle_moins_impute = row.montant_regle - row.montant_impute; // Solde à régler

                row.solde = row.mt_a_percevoir_ttc + row.retenue_garantie - row.montant_regle + row.montant_impute; // Les factures imputables ont un solde négatif

                row.idc_imputable = row.solde < 0; // Période de gestion : Année + Mois (YYYYMM)

                row.anneemois = row.date_facture.substring(0, 4) + '' + row.date_facture.substring(5, 7);
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 2.2.1 --> Hydrate factures');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 2.2.2 --> Commit factures');
              commit('SET_FACTURES', factures);
              /* ---------------------------------------
               *  Hydratation: Injection de propriété pour chaque règlement
               * ---------------------------------------
               *
               *   - facture: la facture parente du règlement
               *   - imputation: la facture à imputer (si le mode de paiement est imputation)
               *
               */

              reglements.forEach(function (row) {
                // Facture parente
                row.facture = factures.find(function (x) {
                  return x.id === row.id_facture;
                }) || null; // Facture à imputer

                row.imputation = factures.find(function (x) {
                  return x.id === row.id_imputation;
                }) || null;
              });
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 2.3.1 --> Hydrate reglements');
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] 2.3.2 --> Commit reglements');
              commit('SET_REGLEMENTS', reglements);
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] -- ENDED');
              return _context4.abrupt("return", true);

            case 57:
              _context4.prev = 57;
              _context4.t0 = _context4["catch"](4);
              if (debug) console.log('   [Facturation Store][Action  ] [hydrateCreances] -- ENDED with error'); // return new Error(error)

              console.error(_context4.t0);

            case 61:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[4, 57]]);
    }));

    function hydrateCreances(_x4) {
      return _hydrateCreances.apply(this, arguments);
    }

    return hydrateCreances;
  }(),

  /* ---------------------------------------
   *  Liste des taux de TVA
   * ---------------------------------------
   *  Chargement de tous les taux de TVA.
   */
  getTauxTva: function getTauxTva(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;
    return apiTva.getAll().then(function (results) {
      commit('SET_TAUX_TVA', results);
    });
  },
  // --- GESTION COMMANDES --- //
  insertCommande: function insertCommande(_ref8, commande) {
    var commit = _ref8.commit,
        state = _ref8.state,
        dispatch = _ref8.dispatch;
    return apiCommande.insert(commande).then(function (results) {
      commande.id = results.insertId;
      commit('ADD_COMMANDE', commande);
      return dispatch('init');
    });
  },
  updateCommande: function updateCommande(_ref9, commande) {
    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;
    return apiCommande.update(commande.id, commande).then(function (results) {
      commit('UPD_COMMANDE', commande);
      return dispatch('init');
    });
  },
  deleteCommande: function deleteCommande(_ref10, commande) {
    var commit = _ref10.commit,
        state = _ref10.state,
        dispatch = _ref10.dispatch;
    return apiCommande.deleteById(commande.id).then(function (results) {
      commit('DEL_COMMANDE', commande);
      return dispatch('hydrate');
    });
  },
  deleteCommandeAndLinkedData: function deleteCommandeAndLinkedData(_ref11, commande) {
    var commit = _ref11.commit,
        state = _ref11.state,
        dispatch = _ref11.dispatch;
    var selection = [commande.id].join(',');
    return dispatch('bulkDeleteCommandeAndLinkedData', selection);
  },
  bulkDeleteCommande: function bulkDeleteCommande(_ref12, selection) {
    var commit = _ref12.commit,
        state = _ref12.state,
        dispatch = _ref12.dispatch;
    return apiCommande.bulkDelete(selection).then(function (results) {
      commit('BULK_DEL_COMMANDE', selection);
      return dispatch('hydrate');
    });
  },
  bulkDeleteCommandeAndLinkedData: function bulkDeleteCommandeAndLinkedData(_ref13, selection) {
    var commit = _ref13.commit,
        state = _ref13.state,
        getters = _ref13.getters,
        dispatch = _ref13.dispatch;
    // Factures liées à la commande
    var factureList = getters.getFactureListByCommandeSelection(selection);
    var factureNb = factureList.length;
    var factureSelection = factureList.map(function (u) {
      return u.id;
    }).join(','); // Réglements liés aux Factures (liées à la commande)

    var reglementList = getters.getReglementListByFactureOrImputationSelection(factureSelection);
    var reglementNb = reglementList.length;
    var reglementSelection = reglementList.map(function (u) {
      return u.id;
    }).join(','); // Suppression en cascade

    return new Promise(function (resolve, reject) {
      if (reglementNb === 0) {
        return resolve();
      } // Suppression des réglements


      return apiReglement.bulkDelete(reglementSelection).then(function (_) {
        resolve();
      });
    }).then(function (_) {
      if (factureNb === 0) {
        return Promise.resolve();
      } // Suppression des factures


      return apiFacture.bulkDelete(factureSelection);
    }).then(function (_) {
      // Suppression des commandes
      return apiCommande.bulkDelete(selection);
    }).then(function (_) {
      // Initialisation des données de facturation
      return dispatch('init');
    });
  },
  // --- GESTION FACTURES --- //
  // getFacturesByCommandeId ({ commit, state, dispatch }, idCommande) {
  getFacturesByCommandeId: function () {
    var _getFacturesByCommandeId = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee5(_ref14, idCommande) {
      var commit, state, dispatch, facturation;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref14.commit, state = _ref14.state, dispatch = _ref14.dispatch;
              _context5.next = 3;
              return dispatch('init');

            case 3:
              facturation = _context5.sent;
              return _context5.abrupt("return", new Promise(function (resolve, reject) {
                if (facturation !== true) {
                  reject(new Error('Les données de facturation n\'ont pas pû être récupérées.'));
                }

                var results = state.commandes.filter(function (x) {
                  return x.id === idCommande;
                });
                resolve(results); // --

                /*
                apiFacture.getAllByCommandeId(idCommande)
                  .then(results => {
                    const commandes = state.commandes
                    const tauxTva = state.tauxTva
                     // injection des commandes et taux de TVA liées aux factures
                    results.forEach((row) => {
                      const commande = commandes.find(x => x.id === row.id_commande)
                      row.commande = commande || null
                      const tva = tauxTva.find(x => x.id === row.id_tva)
                      row.tva = tva || ''
                    })
                     commit('SET_FACTURES', results)
                    resolve(results)
                  })
                  .catch(error => {
                    reject(error)
                  })
                  */
              }));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function getFacturesByCommandeId(_x5, _x6) {
      return _getFacturesByCommandeId.apply(this, arguments);
    }

    return getFacturesByCommandeId;
  }(),
  getFactureForCurrentAffaire: function getFactureForCurrentAffaire(_ref15) {
    var commit = _ref15.commit,
        state = _ref15.state,
        dispatch = _ref15.dispatch;
    return new Promise(function (resolve, reject) {
      apiFacture.getAllByAffaireId(state.affaire.id).then(function (results) {
        var commandes = state.commandes;
        var tauxTva = state.tauxTva; // injection des commandes et taux de TVA liées aux factures

        results.forEach(function (row) {
          row.commande = commandes.find(function (x) {
            return x.id === row.id_commande;
          }) || null;
          row.tva = tauxTva.find(function (x) {
            return x.id === row.id_tva;
          }) || '';
        });
        commit('SET_FACTURES', results);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loadFactureById: function loadFactureById(_ref16, id) {
    var commit = _ref16.commit,
        state = _ref16.state,
        dispatch = _ref16.dispatch;
    return new Promise(function (resolve, reject) {
      apiFacture.getById(id).then(function (results) {
        commit('SET_ORIGINE_REGLEMENT', 'creance');
        commit('SET_FACTURES', results);
        commit('SET_FACTURE', results[0]);
        dispatch('hydrateByFacture').then(function (_) {
          resolve(results);
        });
      }).catch(function (error) {
        console.warn('error', error);
        reject(error);
      });
    });
  },
  insertFacture: function insertFacture(_ref17, _ref18) {
    var commit = _ref17.commit,
        state = _ref17.state,
        dispatch = _ref17.dispatch;
    var facture = _ref18.facture,
        fichier = _ref18.fichier;
    return apiFacture.insert(facture).then(function (results) {
      facture.id = results.insertId;
      commit('ADD_FACTURE', facture);
      fichier.id = facture.id;
      return dispatch('uploadFacturePdf', fichier);
    }).then(function (_) {
      return dispatch('init');
    });
  },
  updateFacture: function updateFacture(_ref19, _ref20) {
    var commit = _ref19.commit,
        state = _ref19.state,
        dispatch = _ref19.dispatch;
    var facture = _ref20.facture,
        fichier = _ref20.fichier;
    return apiFacture.update(facture.id, facture).then(function (results) {
      commit('UPD_FACTURE', facture);
      fichier.id = facture.id;
      return dispatch('uploadFacturePdf', fichier);
    }).then(function (_) {
      return dispatch('init');
    });
  },
  setFactureCommentaire: function setFactureCommentaire(_ref21, facture) {
    var commit = _ref21.commit,
        state = _ref21.state,
        dispatch = _ref21.dispatch;
    return apiFacture.update(facture.id, facture).then(function (results) {
      commit('SET_FACTURE_COMMENTAIRE', facture);
      return dispatch('hydrate');
    });
  },
  uploadFacturePdf: function uploadFacturePdf(_ref22, payload) {
    var commit = _ref22.commit;
    var factureId = payload.id;
    var deleteFichier = payload.deleteFichier;
    var newFichier = payload.newFichier;
    return new Promise(function (resolve, reject) {
      // 1. Upload du nouveau fichier si présent
      // si aucun nouveau fichier ne doit être uploader
      if (!newFichier) {
        return resolve({
          fileUploaded: false
        });
      } // upload d'un nouveau fichier


      var formData = new FormData();
      formData.append('file', newFichier);
      return apiFacture.upload(factureId, formData).then(function (results) {
        commit('SET_FACTURE_FICHIER', {
          id: factureId,
          fichier: results.fichier.path,
          nom_original: results.fichier.name
        });
        resolve({
          fileUploaded: true
        });
      }).catch(function (error) {
        console.error(error);
      });
    }).then(function (results) {
      // 2. Suppression physique du fichier actuel si demandé
      // Un fichier a-t-il été uploadé ?
      var fileUploaded = results.fileUploaded; // si l'utilisateur ne souhaite pas supprimer le fichier actuellement stocké

      if (deleteFichier !== true) {
        // on passe à la suite
        return Promise.resolve();
      } // si l'utilisateur souhaite supprimer le fichier actuellement stocké
      // mais qu'il a réussi à uploader un nouveau fichier


      if (fileUploaded === true) {
        // on passe à la suite
        return Promise.resolve();
      } // suppression du fichier actuellement stocké


      return apiFacture.deleteFactureFichier(factureId).then(function (results) {
        if (!fileUploaded) {
          commit('UNSET_FACTURE_FICHIER', factureId);
        }

        Promise.resolve();
      }).catch(function (error) {
        console.error(error);
      });
    });
  },
  getFactureFichier: function getFactureFichier(_ref23, facture) {
    var commit = _ref23.commit,
        state = _ref23.state,
        dispatch = _ref23.dispatch;
    return apiFacture.getFactureFichier(facture);
  },
  deleteFacture: function deleteFacture(_ref24, facture) {
    var commit = _ref24.commit,
        state = _ref24.state,
        dispatch = _ref24.dispatch;
    return apiFacture.deleteById(facture.id).then( /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee6(results) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit('DEL_FACTURE', facture);
                return _context6.abrupt("return", dispatch('hydrate'));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x7) {
        return _ref25.apply(this, arguments);
      };
    }());
  },
  deleteFactureAndLinkedData: function deleteFactureAndLinkedData(_ref26, facture) {
    var commit = _ref26.commit,
        state = _ref26.state,
        dispatch = _ref26.dispatch;
    var selection = [facture.id].join(',');
    return dispatch('bulkDeleteFactureAndLinkedData', selection);
  },
  bulkDeleteFacture: function bulkDeleteFacture(_ref27, selection) {
    var commit = _ref27.commit,
        state = _ref27.state,
        dispatch = _ref27.dispatch;
    return apiFacture.bulkDelete(selection).then( /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee7(_) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commit('BULK_DEL_FACTURE', selection);
                return _context7.abrupt("return", dispatch('hydrate'));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x8) {
        return _ref28.apply(this, arguments);
      };
    }());
  },
  bulkDeleteFactureAndLinkedData: function bulkDeleteFactureAndLinkedData(_ref29, selection) {
    var commit = _ref29.commit,
        state = _ref29.state,
        getters = _ref29.getters,
        dispatch = _ref29.dispatch;
    // Réglements liés aux Factures (liées à la commande)
    var reglementList = getters.getReglementListByFactureOrImputationSelection(selection);
    var reglementNb = reglementList.length;
    var reglementSelection = reglementList.map(function (u) {
      return u.id;
    }).join(','); // Suppression en cascade

    return new Promise(function (resolve, reject) {
      if (reglementNb === 0) {
        return resolve();
      } // Suppression des réglements


      return apiReglement.bulkDelete(reglementSelection).then(function (_) {
        resolve();
      });
    }).then(function (_) {
      // Suppression des factures
      return apiFacture.bulkDelete(selection);
    }).then(function (_) {
      // Initialisation des données de facturation
      return dispatch('init');
    });
  },
  // --- GESTION REGLEMENTS --- //
  insertReglement: function insertReglement(_ref30, reglement) {
    var commit = _ref30.commit,
        state = _ref30.state,
        dispatch = _ref30.dispatch;
    return apiReglement.insert(reglement).then(function (results) {
      reglement.id = results.insertId;
      commit('ADD_REGLEMENT', reglement);

      if (state.origineReglement === 'creance') {
        return dispatch('hydrateByFacture');
      }

      return dispatch('init');
    });
  },
  updateReglement: function updateReglement(_ref31, reglement) {
    var commit = _ref31.commit,
        state = _ref31.state,
        dispatch = _ref31.dispatch;
    return apiReglement.update(reglement.id, reglement).then(function (results) {
      commit('UPD_REGLEMENT', reglement);

      if (state.origineReglement === 'creance') {
        return dispatch('hydrateByFacture');
      }

      return dispatch('init');
    });
  },
  deleteReglement: function deleteReglement(_ref32, reglement) {
    var commit = _ref32.commit,
        state = _ref32.state,
        dispatch = _ref32.dispatch;
    return apiReglement.deleteById(reglement.id).then(function (results) {
      commit('DEL_REGLEMENT', reglement);

      if (state.origineReglement === 'creance') {
        // return dispatch('loadFactureById', reglement.facture_id)
        return dispatch('hydrateByFacture');
      }

      return dispatch('hydrate');
    });
  },
  bulkDeleteReglement: function bulkDeleteReglement(_ref33, selection) {
    var commit = _ref33.commit,
        state = _ref33.state,
        dispatch = _ref33.dispatch;
    return apiReglement.bulkDelete(selection).then(function (results) {
      commit('BULK_DEL_REGLEMENT', selection);

      if (state.origineReglement === 'creance') {
        return dispatch('hydrateByFacture');
      }

      return dispatch('hydrate');
    });
  },
  // --- GESTION CREANCES (FACTURES NON SOLDÉES) --- //
  getCreances: function getCreances(_ref34) {
    var commit = _ref34.commit,
        state = _ref34.state,
        dispatch = _ref34.dispatch;
    // Liste des créances
    return apiFacture.getCreances().then(function (results) {
      var creances = [];
      /* ---------------------------------------
       *  Préparation: Regroupement des créances par facture
       * ---------------------------------------
       *
       */

      results.forEach(function (row) {
        var creance = creances.find(function (x) {
          return x.facture.id === row.facture_id;
        }); // Si la créance n'est pas encore mémorisée

        if (typeof creance === 'undefined') {
          // Données de la créance
          var data = _objectSpread({}, row, {
            affaire: {
              'id': row.affaire_id,
              'secteur_geo_code': row.secteur_geo_code,
              'secteur_geo_libelle': row.secteur_geo_libelle,
              // 'client': row.client_libelle,
              // 'enseigne': row.enseigne_libelle,
              client: {
                id: row.client_id,
                libelle: row.client_libelle
              },
              enseigne: {
                id: row.enseigne_id,
                libelle: row.enseigne_libelle
              },
              'nom': row.affaire_nom,
              'num_affaire': row.affaire_num_affaire
            },
            commande: {
              'numero': row.commande_numero
            },
            facture: {
              'id': row.facture_id,
              'date_facture': row.facture_date_facture,
              'numero': row.facture_numero,
              'libelle': row.facture_libelle,
              'retenue_garantie': row.facture_retenue_garantie,
              'mt_avant_paiement_direct_ttc': row.facture_mt_avant_paiement_direct_ttc,
              'mt_a_percevoir_ttc': row.facture_mt_a_percevoir_ttc,
              'date_echeance': row.facture_date_echeance,
              'nb_reglement': row.facture_nb_reglement,
              'mt_regle': row.facture_mt_regle,
              'solde': row.facture_solde,
              'commentaire': row.facture_commentaire,
              'fichier': row.facture_fichier,
              'nom_original': row.facture_nom_original
            },
            reglements: []
          });

          creances.push(data);
        }

        if (row.facture_nb_reglement > 0) {
          // Règlement
          var reglement = {
            'montant': row.reglement_montant,
            'date': row.reglement_date,
            'mode': row.reglement_mode
          }; // Ajout du règlement

          creance = creances.find(function (x) {
            return x.facture.id === row.facture_id;
          });
          creance.reglements.push(reglement);

          if (creance.reglements.length > 1) {
            creance.reglement_montant = null;
            creance.reglement_date = null;
            creance.reglement_mode = null;
          }
        }
      });
      commit('SET_CREANCES', creances); // return creances
    });
  },
  loadSyntheseList: function loadSyntheseList(_ref35) {
    var commit = _ref35.commit,
        state = _ref35.state,
        dispatch = _ref35.dispatch;
    // Liste des créances
    return apiFacture.getSyntheseList().then(function (results) {
      var list = [];
      /* ---------------------------------------
       *  Préparation: Sans regroupement des règlements par facture
       * ---------------------------------------
       *
       */

      results.forEach(function (row) {
        // Données de la créance
        var data = _objectSpread({}, row, {
          affaire: {
            'id': row.affaire_id,
            'nom': row.affaire_nom,
            'code_analytique': row.affaire_code_analytique,
            'num_affaire': row.affaire_num_affaire,
            // 'secteur_geo_code': row.secteur_geo_code,
            // 'secteur_geo_libelle': row.secteur_geo_libelle,
            // 'secteur_act_code': row.secteur_act_code,
            // 'secteur_act_libelle': row.secteur_act_libelle,
            // 'client': row.client_libelle,
            // 'enseigne': row.enseigne_libelle,
            secteur_act: {
              id: row.secteur_act_id,
              code: row.secteur_act_code,
              libelle: row.secteur_act_libelle
            },
            secteur_geo: {
              id: row.secteur_geo_id,
              code: row.secteur_geo_code,
              libelle: row.secteur_geo_libelle
            },
            client: {
              id: row.client_id,
              libelle: row.client_libelle
            },
            enseigne: {
              id: row.enseigne_id,
              libelle: row.enseigne_libelle
            }
          },
          commande: {
            'id': row.commande_id,
            'numero': row.commande_numero,
            'date': row.commande_date,
            'montant': row.commande_montant,
            'nb_facture': row.commande_nb_facture,
            'avancement': row.commande_avancement,
            'solde_ht_a_facturer': row.commande_solde_ht_a_facturer,
            'emetteur': row.commande_emetteur,
            'libelle': row.commande_libelle,
            'commentaire': row.commande_commentaire
          },
          facture: {
            'id': row.facture_id,
            'date_facture': row.facture_date_facture,
            'date_echeance': row.facture_date_echeance,
            'numero': row.facture_numero,
            'libelle': row.facture_libelle,
            'montant_ht': row.facture_montant_ht,
            'montant_tva': row.facture_montant_tva,
            'retenue_garantie': row.facture_retenue_garantie,
            'mt_avant_paiement_direct_ttc': row.facture_mt_avant_paiement_direct_ttc,
            'mt_paiement_direct_st': row.facture_mt_paiement_direct_st,
            'mt_a_percevoir_ttc': row.facture_mt_a_percevoir_ttc,
            'nb_reglement': row.facture_nb_reglement,
            'mt_regle': row.facture_mt_regle,
            'solde': row.facture_solde,
            'commentaire': row.facture_commentaire,
            'fichier': row.facture_fichier,
            'nom_original': row.facture_nom_original
          },
          reglement: {
            'id': row.reglement_id,
            'montant': row.reglement_montant,
            'date': row.reglement_date,
            'mode': row.reglement_mode
          },
          reglements: []
        });

        if (row.facture_nb_reglement > 0) {
          // Règlement
          var reglement = {
            'montant': row.reglement_montant,
            'date': row.reglement_date,
            'mode': row.reglement_mode
          }; // Ajout du règlement

          data.reglements.push(reglement);
        }

        list.push(data);
      });
      commit('SET_SYNTHESE_LIST', list);
    });
  },
  setCreanceCommentaire: function setCreanceCommentaire(_ref36, payload) {
    var commit = _ref36.commit,
        state = _ref36.state,
        dispatch = _ref36.dispatch;
    return apiFacture.update(payload.id, payload).then(function (results) {
      commit('SET_CREANCE_COMMENTAIRE', payload);
    });
  }
};
var getters = {
  // --- Taux de TVA
  getTauxTvaList: function getTauxTvaList(state) {
    return state.tauxTva;
  },
  getTauxTvaById: function getTauxTvaById(state) {
    return function (id) {
      return state.tauxTva.find(function (x) {
        return x.id === id;
      });
    };
  },
  // --- Commandes
  getCommandeListForCurrentAffaire: function getCommandeListForCurrentAffaire(state) {
    return state.commandes;
  },
  getCommandeById: function getCommandeById(state) {
    return function (id) {
      return state.commandes.find(function (x) {
        return x.id === id;
      });
    };
  },
  // --- Factures
  getFactureList: function getFactureList(state, getters) {
    return function (id) {
      if (id) {
        return getters.getFactureListByCommande(id);
      } else {
        return getters.getFactureListForCurrentAffaire;
      }
    };
  },
  getFactureListForCurrentAffaire: function getFactureListForCurrentAffaire(state) {
    return state.factures;
  },
  getFactureListByCommande: function getFactureListByCommande(state) {
    return function (id) {
      if (!id) {
        return [];
      }

      return state.factures.filter(function (x) {
        return x.id_commande === id;
      });
    };
  },
  getFactureListByCommandeSelection: function getFactureListByCommandeSelection(state) {
    return function (selection) {
      if (!selection) {
        return [];
      }

      var factureList = [];
      var listIds = selection.split(',');
      listIds.forEach(function (id) {
        var idCommande = Number.parseInt(id);
        var factureListByCommande = state.factures.filter(function (x) {
          return x.id_commande === idCommande;
        });
        factureList = [].concat(_toConsumableArray(factureList), _toConsumableArray(factureListByCommande));
      });
      return factureList;
    };
  },
  getNbFactureByCommandeSelection: function getNbFactureByCommandeSelection(state, getters) {
    return function (selection) {
      return getters.getFactureListByCommandeSelection(selection).length;
    };
  },
  getFactureById: function getFactureById(state) {
    return function (id) {
      var facture = state.factures.find(function (x) {
        return x.id === id;
      });
      return facture;
    };
  },
  // --- Réglements
  getReglementList: function getReglementList(state, getters) {
    return function (id) {
      if (id) {
        return getters.getReglementListByFacture(id);
      }

      return getters.getReglementListForCurrentAffaire;
    };
  },
  getReglementListForCurrentAffaire: function getReglementListForCurrentAffaire(state) {
    return state.reglements;
  },
  getReglementListByFacture: function getReglementListByFacture(state) {
    return function (id) {
      if (!id) {
        return [];
      }

      var reglements = state.reglements.filter(function (x) {
        return x.id_facture === id || x.id_imputation === id;
      });
      reglements.forEach(function (row) {
        // Règlement imputé : lié à une facture dont tout ou partie du trop-perçu a été utilisé pour régler une autre facture
        row.is_imputed = row.id_imputation === id;

        if (row.is_imputed) {
          row.imputed_amount = -row.montant;
        }
      });
      return reglements; // return state.reglements.filter(x => x.id_facture === id)
    };
  },
  getReglementListByFactureSelection: function getReglementListByFactureSelection(state) {
    return function (selection) {
      if (!selection) {
        return [];
      }

      var reglementList = [];
      var listIds = selection.split(',');
      listIds.forEach(function (id) {
        var tmpList = state.reglements.filter(function (x) {
          return x.id_facture === Number.parseInt(id);
        });
        reglementList = [].concat(_toConsumableArray(reglementList), _toConsumableArray(tmpList));
      });
      return reglementList;
    };
  },
  getReglementListByFactureOrImputation: function getReglementListByFactureOrImputation(state) {
    return function (id) {
      if (!id) {
        return [];
      }

      var reglementListByFacture = state.reglements.filter(function (x) {
        return x.id_facture === id;
      });
      var reglementListByImputation = state.reglements.filter(function (x) {
        return x.id_imputation === id;
      });
      return [].concat(_toConsumableArray(reglementListByFacture), _toConsumableArray(reglementListByImputation));
    };
  },
  getReglementListByFactureOrImputationSelection: function getReglementListByFactureOrImputationSelection(state) {
    return function (selection) {
      if (!selection) {
        return [];
      }

      var reglementList = [];
      var listIds = selection.split(',');
      listIds.forEach(function (id) {
        var idFacture = Number(id);
        var reglementListByFacture = state.reglements.filter(function (x) {
          return x.id_facture === idFacture;
        });
        var reglementListByImputation = state.reglements.filter(function (x) {
          return x.id_imputation === idFacture;
        });
        reglementList = [].concat(_toConsumableArray(reglementList), _toConsumableArray(reglementListByFacture), _toConsumableArray(reglementListByImputation));
      });
      return reglementList;
    };
  },
  getNbReglementByFactureOrImputationSelection: function getNbReglementByFactureOrImputationSelection(state, getters) {
    return function (selection) {
      return getters.getReglementListByFactureOrImputationSelection(selection).length;
    };
  },
  // --- Créances
  getCreanceList: function getCreanceList(state) {
    return state.creances;
  },
  // --- Synthèse générale
  getSyntheseList: function getSyntheseList(state) {
    return state.syntheseList;
  },
  getOrigineReglement: function getOrigineReglement(state) {
    return state.origineReglement;
  },
  getFacturationSoldee: function getFacturationSoldee(state) {
    return state.facturationSoldee;
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
exports.default = _default;